import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { domainResolver } from './utils';

const lng = domainResolver();

const resources = {};
resources[lng] = { translation: require(`../public/assets/translations/${lng}.json`) };

i18n.use(initReactI18next).init({
  resources,
  lng,
  fallbackLng: lng,
  debug: false,
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
  },
});

export default i18n;
